let trigger = true;
const navHeight = 73;

function repeatOften() {
  const navbar = document.getElementById('navbar-home');
  const currentScrollPos = window.pageYOffset;

  if (!navbar) {
    return;
  }

  if (currentScrollPos + navHeight > window.innerHeight && !trigger) {
    navbar.classList.remove('navbar--transparent');

    trigger = true;
  } else if (currentScrollPos + navHeight < window.innerHeight && trigger) {
    navbar.classList.add('navbar--transparent');
    trigger = false;
  }

  requestAnimationFrame(repeatOften);
}
if (window.location.href.indexOf('.test') === -1) {
  requestAnimationFrame(repeatOften);
}
